import { render, staticRenderFns } from "./HubSummaryActualCases.vue?vue&type=template&id=589eb192"
import script from "./HubSummaryActualCases.vue?vue&type=script&lang=js"
export * from "./HubSummaryActualCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports